import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "element-ui/lib/theme-chalk/index.css";
import { Button, Carousel, CarouselItem ,Image, Input } from "element-ui";
Vue.use(Button)
  .use(Carousel)
  .use(CarouselItem).use(Image).use(Input);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
